import {
	useAccessoryCategories,
	useAccessoryRanges,
	useAccessoryRangesArchived,
	useCo2Labels,
	useTagList,
} from 'context/Store';

export default function useAccessorySearchData() {
	const co2Labels = useCo2Labels();
	const accessoryCategories = useAccessoryCategories();
	const ranges = useAccessoryRanges();
	const rangesArchived = useAccessoryRangesArchived();
	const tags = useTagList();

	return {
		accessoryCategories,
		co2Labels,
		ranges,
		rangesArchived,
		tags,
	};
}
